import React from 'react'
import  successIcon from "styleguide/icons/ds2/checkmarkcirclesolid.svg";
import  errorIcon from "styleguide/icons/ds2/errorcirclesolid.svg";
interface NotificationsProps {
  messageInfo?: string;
  // status: true = success, false = error
  status?: boolean;
}

const Notifications: React.FC<NotificationsProps> = ({ messageInfo , status}) => {
  const variant = status ? 'Success' : 'Error';
  return (
    <div className='!mt-8 lg:!mt-0'>
      <section
        aria-live="assertive"
        className="ds-notification ds-notification--dismiss !p-3"
        data-ds-version="1"
        data-ds-theme="vessel"
        data-ds-variant={variant}
        aria-labelledby="ds-notification__heading-0"
      >
        <div className="ds-notification__icon">
          <img src={status ? successIcon : errorIcon} alt={variant} width={40} height={40} />
        </div>
        <div className="ds-notification__main-icon">
          <div className="ds-notification__header">
            <div
              className="ds-notification__heading"
              id="ds-notification__heading-0"
            >
              {variant}
            </div>
          </div>
          <div className="ds-notification__body">
            {status ? (
              <p className="p4 -book !text-[13px] md:p3 -book md:!text-[14px] lg:p3 -book lg:!text-[16px]">
                {messageInfo}
              </p>
            ) : (
              <p>
                {messageInfo}
              </p>
            )}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Notifications;
